import { Component, Host, h, Prop, State } from '@stencil/core';
import Star2 from "../../assets/svg/star2.svg";

@Component({
  tag: 'salla-reviews-summary',
  styleUrl: 'salla-reviews-summary.scss'
})
export class SallaReviewsSummary {
  constructor() {
    salla.lang.onLoaded(() => {
      const setNestedAsync = (lang, key, value) => {
        return new Promise((resolve) => {
          salla.helpers.setNested(salla.lang.messages[lang], key, value);
          resolve(true);
        });
      };

      const setTranslations = async () => {
        await setNestedAsync('ar.trans', 'blocks.comments.based_on', 'بناءً على');
        await setNestedAsync('en.trans', 'blocks.comments.based_on', 'Based on');

        this.basedOnLabel = salla.lang.get('blocks.comments.based_on');
      };

      setTranslations();
    });
  }

  /**
   * Product ID
   */
  @Prop() itemId!: number;

  @State() canRender: boolean = false;
  @State() data: any;
  @State() basedOnLabel: string;

  componentWillLoad() {
    return salla.onReady()
      .then(() => this.loadSummary());
  }

  private async loadSummary() {
    try {
      let resp = await salla.api.request(`rating/summary/${this.itemId}`);
      if (Array.isArray(resp.data.reviews) && !resp.data.reviews.length) {
        return this.canRender = false;
      } else {
        this.data = resp.data;
        this.canRender = true;
      }
    } catch (error) {
      console.error('Error loading reviews summary:', error);
    }
  }

  render() {
    if (!this.canRender) {
      return null;
    }

    // Initialize all ratings with 0 if missing
    const ratings = {
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      ...this.data.reviews
    };


    const reviewElements = Object.keys(ratings).reverse().map(rating => {
      const percentage = ratings[rating];
      return (
        <div class="s-reviews-summary-row">
          <div class="s-reviews-summary-row-rate">{rating} <span innerHTML={Star2}></span></div>
          <salla-progress-bar class="s-reviews-summary-progress" value={percentage} target={100} hideUnits={true} height='14px'></salla-progress-bar>
          <span class="s-reviews-summary-percentage">{percentage}%</span>
        </div>
      );
    });

    return (
      <Host class="s-reviews-summary-wrapper">
        <div class="s-reviews-summary-header">
          <h3 class="s-reviews-summary-average">{this.data.rating}</h3>
          <div>
            <salla-rating-stars value={this.data.rating}></salla-rating-stars>
            <p class="s-reviews-summary-count">{this.basedOnLabel} {salla.helpers.number(salla.lang.choice('pages.rating.reviews', this.data.count))}</p>
          </div>
        </div>
        <div class="s-reviews-summary-rows">
          {reviewElements}
        </div>
      </Host>
    );
  }
}
